<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <!-- Dialog export -->
          <v-col cols="12">
            <v-btn color="yellow-light" @click="exportData()">
              <v-icon left>mdi-download</v-icon>
              Export Data
            </v-btn>
          </v-col>

          <!-- DIALOG dialogTransfer -->
          <v-dialog v-model="dialogTransfer" persistent max-width="50%">
            <v-card>
              <v-card-title class="text-h6 grey lighten-2">
                อัพเดทสถานะพนักงาน
              </v-card-title>
              <v-col>
                <v-alert shaped dense outlined dark type="warning">
                  กรุณาตรวจสอบ สถานะพนักงานให้ถูกต้อง
                  จะบันทึกเป็นประวัติการทำงาน
                </v-alert>
              </v-col>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-card-text>
                        <v-autocomplete
                          outlined
                          dense
                          v-model="formUpdateTranfer.positionType"
                          :items="positionTypeSelete"
                          label="ประเภทของ พนักงาน"
                        ></v-autocomplete>
                      </v-card-text>
                    </v-col>
                    <v-col cols="12">
                      <v-row class="">
                        <v-subheader>วันที่สิ้นสุดพนักงานทดลองงาน:</v-subheader>
                      </v-row>
                      <v-col cols="12">
                        <v-menu
                          v-model="menuDate"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formUpdateTranfer.endDate"
                              prepend-icon="mdi-calendar"
                              readonly
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            locale="th-th"
                            v-model="formUpdateTranfer.endDate"
                            @input="menuDate = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  depressed
                  @click="dialogTransfer = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  depressed
                  color="success"
                  @click="editDataTransfer(formUpdateTranfer)"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ยืนยัน
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end dialogTransfer -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="orange darken-4"
                      dark
                      fab
                      small
                      @click.stop=";(dialogTransfer = true), setUpdate(item)"
                    >
                      <v-icon dark> mdi-account-arrow-right </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.action3`]="{ item }">
                    <v-btn color="green" dark fab small @click="viewEmp(item)">
                      <v-icon dark> mdi-eye-outline </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      e1: 1,
      PK: '',
      path: '/employee/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ข้อมูลนักศึกษาฝึกงาน',
          disabled: true,
          href: '/HRM/Employee/EmployeeApprentice'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      // menu: false,
      code: 'EMP', // Generate Code
      dialogTransfer: false,
      endDate: '',
      menuDate: '',
      positionTypeSelete: [],
      // panel1: '',
      session: this.$session.getAll(),
      searchAll2: '',
      formUpdate: [],
      formUpdateTranfer: [],
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode', align: 'center' },
        { text: 'ชื่อ-นามสกุล', value: 'empFull_NameTH' },
        { text: 'ประเภทพนักงาน', value: 'positionTypeName' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'บริษัท', value: 'masCompanyName' },
        { text: 'วันเข้าทำงาน', value: 'startDate' },
        { text: 'อายุงาน', value: 'workDate' },
        { text: 'Transfer', value: 'action', sortable: false, align: 'center' },
        { text: 'Detail', value: 'action3', sortable: false, align: 'center' }
      ],
      dataItem: [],
      // End Data Table Config

      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      empCode: '',
      empJobId: ''
    }
  },
  async mounted () {
    await this.getGetTokenForEmployee()
    this.dataReady = false
    // Get Data
    // this.getDataGlobal(this.DNS_IP, this.path)
    await this.getDataEmpProbation()
    this.getEmpPositionSelect()
  },
  methods: {
    async setUpdate (item) {
      this.formUpdateTranfer = []
      // this.formUpdate = []
      console.log('item', item)
      this.formUpdateTranfer.positionCode = item.positionCode
      this.formUpdateTranfer.positionName = item.positionName
      this.formUpdateTranfer.empCode = item.empCode
      this.formUpdateTranfer.masDepartmentName = item.masDepartmentName
      this.formUpdateTranfer.masBranchName = item.masBranchName
      this.formUpdateTranfer.masCompanyName = item.masCompanyName
    },
    async getDataEmpProbation () {
      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee/' + 'get?positionTypeName=นักศึกษาฝึกงาน',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async getEmpPositionSelect () {
      this.positionTypeSelete = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/pos_position_type/find_positionTypeName_Apprentice",
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d
            s.text = d.positionTypeName
            d = s
            this.positionTypeSelete.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    async editDataTransfer (dt) {
      console.log('dt', dt)
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          let dataUpdatePosition = {
            positionCode: dt.positionCode,
            positionTypeCode: dt.positionType.positionTypeCode,
            LAST_USER: this.$session.getAll().data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + '/pos_position/updateTransfer',
              dataUpdatePosition
            )
          let dataUpdateJob = {
            empCode: dt.empCode,
            endDate: dt.endDate,
            empJobStatus: 'สิ้นสุดงาน',
            LAST_USER: this.$session.getAll().data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + '/emp_job_experience/updateTransfer',
              dataUpdateJob
            )
          let dataInsertJob = {
            empCode: dt.empCode,
            positionCode: dt.positionCode,
            startDate: dt.endDate,
            endDate: dt.endDate,
            empJobStatus: 'ดำเนินการ',
            positionName: dt.positionName,
            positionTypeName: dt.positionType.positionTypeName,
            masDepartmentName: dt.masDepartmentName,
            masCompanyName: dt.masCompanyName,
            masBranchName: dt.masBranchName,
            CREATE_USER: this.$session.getAll().data.userName,
            LAST_USER: this.$session.getAll().data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + '/emp_job_experience/addTransfer',
              dataInsertJob
            )
            .then(async response => {
              this.$swal(
                'เรียบร้อย',
                'แก้ไขข้อมูล เรียบร้อย',
                'success'
              )
              this.dialogTransfer = false
              await this.getDataEmpProbation()
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async addData () {
      var data = JSON.parse(localStorage.getItem('data'))
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = data.userName
      this.formAdd.LAST_USER = data.userName
      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.getRunningCodeGlobal(this.DNS_IP, this.code).then(async response => {
        this.formAdd.empCode = response
        this.dataReady = false
        this.submitAdd()
      })
    },
    async submitAdd () {
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          delete this.formAdd['empId']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'add',
              this.formAdd,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async response => {
              // Debug response
              console.log(
                'addDataGlobal DNS_IP + "/employee/" + "add"',
                response
              )

              if (response.status === 200) {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                this.dialogAdd = false
                this.dataReady = true
                this.clearData()
                await this.getDataGlobal(this.DNS_IP, this.path)
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }
    },
    async viewEmp (dt) {
      localStorage.setItem('CanEdit', true)
      localStorage.setItem('roll', 'HR')
      localStorage.setItem('Page', '/HRM/Employee/EmployeeManage')
      localStorage.setItem('dataByHR', JSON.stringify(dt))
      this.$router.push('/HRM/Employee/EmployeeInfo')
    },
    async saerchDataAdvanced () {
      var search = ''
      var check = false
      // config วันที่สร้าง วันที่แก้ไข
      // config นำวันที่สิ้นสุดมาต่อ 23:59:59
      if (
        this.search.create_date_start !== '' &&
        this.search.create_date_end === ''
      ) {
        this.search.create_date_end =
          this.search.create_date_start + ' 23:59:59'
      } else {
        if (this.search.create_date_start !== '') {
          this.search.create_date_end =
            this.search.create_date_end + ' 23:59:59'
        }
      }

      if (
        this.search.last_date_start !== '' &&
        this.search.last_date_end === ''
      ) {
        this.search.last_date_end = this.search.last_date_start + ' 23:59:59'
      } else {
        if (this.search.last_date_end !== '') {
          this.search.last_date_end = this.search.last_date_end + ' 23:59:59'
        }
      }
      for (var key in this.search) {
        check = true
        if (this.search[key]) {
          if (search !== '') {
            search += '&'
          }
          search += key + '=' + this.search[key]
        }

        if (
          this.search.last_date_start === '' &&
          this.search.last_date_end !== ''
        ) {
          check = false
          this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่แก้ไข เริ่มต้น', 'error')
        }

        if (
          this.search.create_date_start === '' &&
          this.search.create_date_end !== ''
        ) {
          check = false
          this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่สร้าง เริ่มต้น', 'error')
        }
      }
      //
      //
      // สำหรับ ค้นหาแบบ กำหนดจาก form serach
      //
      if (check === true) {
        this.dataReady = false

        this.saerchDataAdvancedGlobal(this.DNS_IP, this.path, search)
      } else {
        this.dataReady = true
      }
    },
    // * Option Import Excel
    // * ตั้งค่าจาก Data
    importData (event) {
      var input = event.target
      var reader = new FileReader()
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach(sheetName => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          this.dataItemImport = rowObj
        })
        if (this.dataItemImport.length === 0) {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง')
        } else {
          this.dataItemImportChecKHide = false
        }
      }

      reader.readAsBinaryString(input.files[0])
    },
    importDataApprove (action) {
      var titleMsg = ''
      var checkError = false
      if (action === 'add') {
        titleMsg = 'ท่านต้องการ นำเข้าข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      } else if (action === 'delete') {
        titleMsg = 'ท่านต้องการ ลบข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      } else {
        titleMsg = 'ท่านต้องการ ปรับปรุงข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      }

      this.$swal({
        title: titleMsg,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          for (var key in this.dataItemImport) {
            this.PK = this.dataItemImport[key].empId
            if (action === 'add') {
              await this.importDataAdd(this.dataItemImport[key])
              checkError = true
            } else {
              await axios
                .get(
                  // eslint-disable-next-line quotes
                  this.DNS_IP +
                    this.path +
                    'get?empId=' +
                    this.dataItemImport[key].empId,
                  {
                    headers: {
                      'Application-Key': this.$session.getAll().ApplicationKey
                    }
                  }
                )
                .then(async response => {
                  if (action === 'update') {
                    await this.importDataUpdate(this.dataItemImport[key])
                    checkError = true
                  }
                  if (action === 'delete') {
                    await this.importDataDelete(this.dataItemImport[key])
                    checkError = true
                  }
                })
                // eslint-disable-next-line handle-callback-err
                .catch(error => {
                  checkError = false

                  console.log('error /master_title/get?empId : ', error)
                })
            }
          }
          console.log(checkError)
          if (checkError === true) {
            await this.getDataGlobal(this.DNS_IP, this.path)
          } else {
            this.dataItemImport = []
            this.dataItemImportChecKHide = true
            alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          }
        })
        .catch(error => {
          console.log('error function importDataApprove : ', error)
          this.dataReady = true
        })
    },
    async importDataAdd (dt) {
      // Object.assign(this.formAdd, dt)
      dt.CREATE_USER = this.$session.getAll().data.userName
      dt.LAST_USER = this.$session.getAll().data.userName

      delete dt['empId']
      delete dt['LAST_DATE']
      delete dt['CREATE_DATE']
      delete dt['RECORD_STATUS']
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'add',
          dt,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dialogImport = false
          // Debug response
          console.log('/master_title/add/', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
          console.log('error function importDataAdd addData : ', error)
          this.dataReady = true
        })
    },
    exportData () {
      this.dataItem = []
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee/' + 'get?positionTypeName=นักศึกษาฝึกงาน',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          this.dataItem = response.data
          var tem = []
          response.data.forEach(element => {
            var s = {}
            console.log(element)
            s.empId = element.empId
            s.empCode = element.empCode
            s.positionCode = element.positionCode
            s.empTitle_NameTH = element.empTitle_NameTH
            s.empFirst_NameTH = element.empFirst_NameTH
            s.empLast_NameTH = element.empLast_NameTH
            s.positionTypeName = element.positionTypeName
            s.positionName = element.positionName
            s.masDepartmentName = element.masDepartmentName
            s.masBranchName = element.masBranchName
            s.masCompanyName = element.masCompanyName
            s.startDate = element.startDate
            s.workDate = element.workDate
            tem.push(s)
          })
          console.log(tem)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          XLSX.writeFile(wb, 'employee.xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #262a34 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeApprentice.vue